import Vue from 'vue';
import Vuex from 'vuex';
import {SOCKET_URL, URL_IMG} from './defaults';
import instance from "@/plugins/axios-config";


Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    PROJECT_TYPE_TRELLO: 'TRELLO',
    PROJECT_TYPE_KANBAN: 'KANBAN',
    TASK_COMMENT_TYPE_CODE: 'TASK_COMMENT_TYPE',
    TASK_PRIORITY_TYPE_CODE: 'TASK_PRIORITY_TYPE',
    TASK_LEVEL_TYPE_CODE: 'TASK_LEVEL_TYPE',
    TASK_LEVEL_TYPE: {
      HIGH: 'HIGH_LEVEL',
      NORMAL: 'NORMAL_LEVEL',
      LOW: 'LOW_LEVEL',
    },
    TASK_PRIORITY_TYPE: {
      HIGH: 'HIGH_PRIORITY',
      NORMAL: 'NORMAL_PRIORITY',
      LOW: 'LOW_PRIORITY',
    },
    TASK_STATUS_TYPE: {
      RED: 'RED',
      GREEN: 'GREEN',
      YELLOW: 'YELLOW',
      BLUE: 'BLUE',
    },
    TASK_COMMENT_TYPE: {
      SOLUTION: 'TASK_COMMENT_TYPE_DECISION',
      INFORMATION: 'TASK_COMMENT_TYPE_INFORMATION',
      PROBLEM: 'TASK_COMMENT_TYPE_PROBLEM',
    },
    TASK_TIMER: {
      START: 'START',
      STOP: 'STOP',
    },
    loader: false,
    isReportOpen: false,
    url: URL_IMG,
    socketURL: SOCKET_URL,
    refreshTokenIntervalId: 0,
    userProfile: {},
    permissionList: [],
    projectData: null,
    // projectData: projectData,
    projectDataIsFiltered: false,
    dashboardFilter: {
      search: '',
      selectedTag: [],
      selectedMember: [],
      selectedStatus: [],
      selectedPriority: [],
      selectedLevel: [],
    },
    taskModalId: 0,
    taskModalData: null,
    taskPermissions: {},
    taskActionPermission: {},
    projectSelectionList: [],
    createModalTaskId: 0,
    taskModalActionStarter: 0,
    colorList: [
      '#7d97c7',
      '#333c40',
      '#ae2b41',
      '#916dd5',
      '#ffba5a',
      '#4acb8b',
      '#fa163f',
      '#12cad6',
      '#7e0cf5',
      '#f45905',
      '#0c9463',
      '#1089ff',
      '#b8ef03',
      '#18ec64',
      '#553cc6',
      '#20baee',
      '#c2d168',
      '#83d93e',
      '#1192fa',
      '#bdf7f0',
      '#bbc121',
      '#ddfe15',
      '#4b1e4e',
      '#6e3710',
    ],
    socket: {
      notification: null,
      online: null,
      task: null,
      column: null,
      action: null,
      move: null,
    },
    rightMenuActionStarter: 0,
    metaData: {
      title: 'Test title',
      description: 'Test description',
      keywords: 'Test keyword',
      image: 'https://etm.crm24.uz/img/favicon.svg',
    },
    faviconSimple: '/img/favicon.svg',
    // faviconAlert: '/img/favicon_alert.png',
    faviconAlert: '/img/favicon.svg',
    notificationAlert: false,
    lastTaskId: localStorage.getItem('lastTaskId') ? Number(localStorage.getItem('lastTaskId')) : null,
    profileActiveClass: '',
  },
  mutations: {
    $SHOW_LOADING(state) {
      state.loader = true
    },
    $CLEAR_LOADING(state) {
      state.loader = false
    },
    SET_PROJECT_DATA(state, payload) {
      state.projectData = payload
    },
    UPDATE_PROJECT_DATA(state, payload) {
      state.projectData = {...state.projectData, ...payload}
    },
    SET_TASK_MODAL_ID(state, id) {
      state.taskModalId = id
    },
    setModalTaskPriorityType(state, data) {
      state.taskModalData = {...state.taskModalData, 'taskPriorityType': data};
    },
    setModalTaskLevelType(state, data) {
      state.taskModalData = {...state.taskModalData, 'taskLevelType': data};
    },
    setProjectSelectionList(state, data) {
      state.projectSelectionList = data;
    },
    setSocketNotification(state, data) {
      state.socket.notification = data;
    },
    setSocketOnline(state, data) {
      state.socket.online = data;
    },
    setSocketTask(state, data) {
      state.socket.task = data;
    },
    setSocketMove(state, data) {
      state.socket.move = data;
    },
    setSocketColumn(state, data) {
      state.socket.column = data;
    },
    setSocketAction(state, data) {
      state.socket.action = data;
    },
    setMembersProject(state, data) {
      state.dashboardFilter.selectedMember = data
    },
    setTaskPermissions(state, data) {
      state.taskPermissions = data
    },
    setSocketUpdate(state, data) {
      state.socket.update = data;
    },
    setSocketComment(state, data) {
      state.socket.comment = data;
    },
    setProjectTags(state, tags) {
      state.projectData.tags = tags;
    },
    setTaskTags(state, tags) {
      state.taskModalData.tags = tags;
    },
    setMemberToTask(state, data) {
      const {columnId, taskId, members} = data
      const column = state.projectData.columns.find(item => item.id === columnId)
      const task = column.tasks.find(item => item.id === taskId)
      task.members = members
    },
    setTagToTask(state, data) {
      const {columnId, taskId, tags} = data
      const column = state.projectData.columns.find(item => item.id === columnId)
      const task = column.tasks.find(item => item.id === taskId)
      task.tagList = tags
    }
  },
  getters: {
    userProfile(state) {
      return state.userProfile
    },
    isAdmin(state) {
      return state.userProfile.roles && state.userProfile.roles.some(r => r.codeName === 'ADMIN')
    },
    isTeamLeader(state) {
      return state.userProfile.roles && state.userProfile.roles.some(r => r.codeName === 'TEAMLIDER')
    }
  },

  actions: {
    async getTaskPermissions({state, commit}, params) {
      if (Object.keys(state.taskPermissions).length) return

      let data;
      await instance.get('tasks', {
        params,
      })
        .then(response => {
          data = response.data.permissions
        });

      commit('setTaskPermissions', data)
    }
  }
});
